module.exports = __webpack_public_path__ + "static/media/team_about_article_img_3.c764e4b8.png";